import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight, Home } from "lucide-react";

export default function NotFound() {
    useEffect(() => {
        const prev = document.title;
        document.title = "Page not found | Purposeful, Inc.";
        let robots = document.querySelector('meta[name="robots"]');
        const origRobots = robots ? robots.getAttribute("content") : null;
        if (!robots) {
            robots = document.createElement("meta");
            robots.setAttribute("name", "robots");
            document.head.appendChild(robots);
        }
        robots.setAttribute("content", "noindex, follow");
        return () => {
            document.title = prev;
            if (origRobots !== null) robots.setAttribute("content", origRobots);
        };
    }, []);

    return (
        <main
            data-testid="not-found-page"
            className="min-h-[80vh] pt-32 pb-24 text-white fingerprint-bg"
        >
            <div className="container-x mx-auto max-w-3xl text-center">
                <div className="overline mb-4">404 · Off the map</div>
                <h1 className="font-display text-6xl md:text-8xl font-semibold tracking-tight leading-none">
                    This page isn't<br />
                    <span className="text-[#D4AF37]">on the shelf.</span>
                </h1>
                <p className="mt-8 text-zinc-400 text-lg leading-relaxed max-w-xl mx-auto">
                    The link you followed might be older than the book, or we
                    moved things around. Try one of the shelves below.
                </p>

                <div className="mt-10 flex flex-wrap justify-center gap-3">
                    <Link to="/" data-testid="not-found-home-cta" className="btn-gold">
                        <Home size={16} /> Back to home
                    </Link>
                    <Link to="/book" data-testid="not-found-book-cta" className="btn-ghost-gold">
                        The Book <ArrowRight size={14} />
                    </Link>
                    <Link to="/network" data-testid="not-found-network-cta" className="btn-ghost-gold">
                        The Network <ArrowRight size={14} />
                    </Link>
                    <Link to="/directory" data-testid="not-found-featured-cta" className="btn-ghost-gold">
                        Directory <ArrowRight size={14} />
                    </Link>
                </div>

                <div className="mt-16 grid sm:grid-cols-3 gap-4 text-left">
                    {[
                        { to: "/about", label: "About", d: "About Chandrashekar Bhat" },
                        { to: "/founder-stories", label: "Founder Stories", d: "Ideas from founders behind Purposeful" },
                        { to: "/join", label: "Waitlist", d: "Join Purposeful" },
                    ].map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            data-testid={`not-found-link-${l.label.toLowerCase()}`}
                            className="card-dark p-6 block"
                        >
                            <div className="overline">{l.label}</div>
                            <div className="text-zinc-300 text-sm mt-2">{l.d}</div>
                        </Link>
                    ))}
                </div>
            </div>
        </main>
    );
}
